<template>
  <BTextField
    v-if="$attrs.disabled"
    v-bind="$attrs"
    :value="valueText"
    v-on="$listeners"
  />
  <BAutocomplete
    v-else
    ref="autocomplete"
    v-bind="$attrs"
    :items="options"
    :request="request"
    :autoselect-on-blur="false"
    v-on="$listeners"
  >
    <template v-for="(_, key) in $scopedSlots" #[key]="props">
      <slot v-bind="props" :name="key" />
    </template>
  </BAutocomplete>
</template>

<script>
import { openApiMixin } from './mixins'
import BAutocomplete from '../BAutocomplete.vue'
import BTextField from '@/components/forms/BTextField.vue'


export default {
  name: 'BAutocompleteSelect',
  components: {
    BTextField,
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  props: {
    options: {
      type: Array,
      required: true,
    },
  },
  computed: {
    valueText() {
      const { $attrs, options } = this
      if (!$attrs) return '---'
      const {
        'item-value': itemValue = 'id',
        'item-text': itemText = 'name',
        'return-object': returnObject,
        value,
      } = $attrs
      const getVal = typeof itemValue === 'function' ? itemValue : (o) => (o?.[itemValue] || o)
      const getText = typeof itemText === 'function' ? itemText : (o) => (o?.[itemText] || o)

      if (typeof value === 'undefined' || value === null) return '---'

      // eslint-disable-next-line eqeqeq
      const valueObj = returnObject ? value : options.filter((o) => getVal(o) == value)?.[0]
      return getText(valueObj)
    },
  },
  methods: {
    request() {
      return {
        data: this.options,
        meta: { count: this.options.length },
      }
    },
  },
}
</script>
